// Utility functions for employee management
import dayjs from 'dayjs';

export const generateUsernameAndNames = (fullName) => {
  if (!fullName) return { username: '', first_name: '', last_name: '' };

  const nameParts = fullName.trim().split(' ');
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';

  // Generate username: first word + first char of second word (lowercase)
  let username = firstName.toLowerCase();
  if (nameParts.length > 1 && nameParts[1]) {
    username += nameParts[1].charAt(0).toLowerCase();
  }

  return {
    username,
    first_name: firstName,
    last_name: lastName,
  };
};

export const getInitialFormData = () => ({
  employee_id: '',
  full_name: '',
  email: '',
  phone: '',
  identity_number: '',
  shift: '',
  designation: '',
  department: '',
  basic_salary: '',
  salary_currency: 'PKR',
  transport_allowance: '0',
  other_allowances: '0',
  tax_deductions: '0',
  take_home_salary: '',
  joining_date: dayjs().format('YYYY-MM-DD'),
  resignation_date: null,
  bank_name: '',
  bank_account_number: '',
  bank_account_title: '',
  remarks: '',
  is_active: true,
});

export const getInitialUserFormData = () => ({
  username: '',
  first_name: '',
  last_name: '',
  password: '',
});
